import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Option } from '../Option';
import { OPTIONS, TTS_OPTIONS } from '../../constants';
import { Container } from './styled';

type TCheckboxListProps<T extends FieldValues> = {
  control: Control<T>;
  isRaskTtsUsed?: boolean;
} & FieldValues;

export const CheckboxList = <T extends FieldValues>({ control, isRaskTtsUsed }: TCheckboxListProps<T>) => {
  const options = isRaskTtsUsed ? TTS_OPTIONS : OPTIONS;

  return (
    <Container>
      {options.map(({ label }, idx) => (
        <Option key={label} control={control} controller={`options.${idx}` as FieldPath<T>}>
          {label}
        </Option>
      ))}
    </Container>
  );
};
